

<app-display-projects-card-view  [allProjectsSetter]="projectsToDisplay" *ngIf="isDataAvailable" ></app-display-projects-card-view>
